import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import ProductCard from '@/app/components/productsCard/productsCard';
import { getDictionary, getField } from '@/app/utils/translation/translation';
import { getSvg } from '@/app/utils/svgUtils';

interface OurProductsProps {
    isMobile: boolean;
    language: any;
    translations: any;
    productsRef: any;
    comingSoon?: boolean;
}

const OurProducts: React.FC<OurProductsProps> = ({ isMobile, language, translations, productsRef }) => {


    const dictionary = getDictionary(translations, 'products', language);
    const langCode = language === 'arabic' ? 'ar' : language === 'french' ? 'fr' : 'en';

    const products = [
        {
            id: 2,
            title: getField(dictionary, 'online-ordering', language),
            image: `${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/webp-images/ORDERING copy.webp`,
            link: getField(dictionary, 'read-more', language),
            href: langCode === 'en' ? `/online-ordering` : `/${langCode}/online-ordering`,
        },
        {
            id: 1,
            title: getField(dictionary, 'crm-marketing', language),
            image: `${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/webp-images/CRM copy.webp`,
            link: getField(dictionary, 'read-more', language),
            href: langCode === 'en' ? `/crm-marketing` : `/${langCode}/crm-marketing`,
        },
        {
            id: 3,
            title: getField(dictionary, 'branded-apps', language),
            image: `${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/webp-images/branded.webp`,
            link: getField(dictionary, 'read-more', language),
            href: langCode === 'en' ? `/branded-apps` : `/${langCode}/branded-apps`,
        },
        {
            id: 4,
            title: getField(dictionary, 'qr-menu', language),
            image: `${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/webp-images/QR CODE - MENU copy.webp`,
            link: getField(dictionary, 'read-more', language),
            href: langCode === 'en' ? `/qr-digital-menu` : `/${langCode}/qr-digital-menu`,
        },
        {
            id: 5,
            title: getField(dictionary, 'loyalty-loyalty', language),
            image: `${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/webp-images/REWARDS copy.webp`,
            link: getField(dictionary, 'read-more', language),
            href: langCode === 'en' ? `/loyalty` : `/${langCode}/loyalty`,
        },
        {
            id: 6,
            title: getField(dictionary, 'qr-ordering', language),
            image: `${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/webp-images/QR ORDERING6.webp`,
            link: getField(dictionary, 'read-more', language),
            href: langCode === 'en' ? `/qr-ordering` : `/${langCode}/qr-ordering`,
        },
        {
            id: 7,
            title: getField(dictionary, 'table-payment', language),
            image: `${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/webp-images/totalpayment.webp`,
            link: getField(dictionary, 'coming-soon', language),
            href: `/table-payment`,
            comingSoon: true,
        },
        {
            id: 8,
            title: getField(dictionary, 'reservation-reservation', language),
            image: `${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/webp-images/RESERVATION.webp`,
            link: getField(dictionary, 'coming-soon', language),
            href: `/reservation-reservation`,
            comingSoon: true,
        },
        {
            id: 9,
            title: getField(dictionary, 'driver-app', language),
            image: `${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/webp-images/DRIVER APP.webp`,
            link: getField(dictionary, 'coming-soon', language),
            href: `/driver-app`,
            comingSoon: true,
        },
    ];


    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', textAlign: "center", justifyContent: "center" }}>
                <div style={{ position: 'relative', zIndex: 0 }}>
                    <Typography component="h2" textAlign={"center"} sx={{ color: "var(--text-primary)" }} fontWeight={"bold"} fontFamily={"Century Gothic"} fontSize={isMobile ? "20px" : "25px"}>
                        {getField(dictionary, 'title', language)}
                    </Typography>
                </div>
                <div style={{ position: 'relative', zIndex: -1, transform: "translate(-6rem , 1rem)" }}>
                    {/* <img src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/products/up-arrow.png`} loading="lazy" style={{ position: 'absolute', width: isMobile ? "50px" : "100px" }} alt="Arrow pointing up" /> */}
                  {getSvg('ourproductsarrow', { darkPurple: 'var(--accent-primary)' }, { width: isMobile ? "50px" : "100px", height: "auto" }, { position: 'absolute' })}
                </div>
            </div>

            <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: "2rem" }}>
                <Grid container spacing={2} sx={{ maxWidth: isMobile ? '1200px' : '900px', justifyContent: 'center' }}>
                    {products.map(product => (
                        <Grid item xs={12} sm={6} md={4} key={product.id} sx={{ display: 'flex', justifyContent: 'center', padding: 0 }}>
                            <ProductCard {...product} isMobile={isMobile} language={language} translations={translations} />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </>
    );
};

export default OurProducts;
